import { UseFormReturn } from 'react-hook-form';
import { DAYS } from 'src/constants';
import { TDay } from '../../types/venue.types';
import { VenueOpeningTimeFields } from '../VenueOpeningTimeFields/VenueOpeningTimeFields';
import { TEditVenueOpeningTimes } from '../VenueOpeningTimeEditModal/types';

export const VenueOpeningTimes = ({
  formFields,
  onDelete,
}: {
  formFields: UseFormReturn<TEditVenueOpeningTimes>;
  onDelete?: (id: string[]) => void;
}) => {
  return (
    <>
      {DAYS.map((day: TDay) => (
        <div key={day} data-cy={`${day.toLowerCase()}-info`}>
          <VenueOpeningTimeFields formFields={formFields} day={day} onDelete={onDelete} />
        </div>
      ))}
    </>
  );
};
